<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container-fluid wow fadeIn">
            <b-button variant="link" class="pl-0 mb-2" @click="goBack">
                &larr; Back to Agent Monthly Sales
            </b-button>

            <legend>Agent Product Report</legend>
            <p v-if="fullName"><strong>{{ fullName }}</strong></p>

            <b-row>
                <b-col sm="6" md="3">
                    <b-form-group label-size="sm" label="Date From:">
                        <b-form-input v-model="dateFrom" type="date" size="sm"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="3">
                    <b-form-group label-size="sm" label="Date To:">
                        <b-form-input v-model="dateTo" type="date" size="sm"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="3">
                    <b-form-group label-size="sm" label="Status:">
                        <b-form-select v-model="success" :options="successOptions" size="sm"></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <br />
                    <b-button type="button" @click="getReport" pill variant="outline-dark">
                        Retrieve Report
                    </b-button>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <strong>Total Records: {{ totalRecords }}</strong>
                </b-col>
            </b-row>

            <div class="row pt-3">
                <div class="col">
                    <div class="table-responsive-md">
                    <b-table striped hover bordered small :items="items" :fields="fields">
                    </b-table>
                    </div>
                    <br />
                    <b-pagination @input="handlePageClick" v-model="selectedPage" :total-rows="totalRecords"
                        :per-page="perPage" first-number last-number></b-pagination>
                </div>
            </div>

            <div class="vld-parent">
                <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
            </div>
        </div>
    </main>
</div>
